import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { MdDeleteOutline } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link } from "react-router-dom";
import "../Inventory/Inventory.css";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

export const SubOrdersAddIncomeStock = () => {
  const [loading, setLoading] = useState(false);
  const [refNo, setRefNo] = useState();
  const [receivedData, setReceivedData] = useState();
  const [additionalNote, setAdditionalNote] = useState();
  const [dropdownProductcode, setDropdownProductCode] = useState();
  const [addStockRow, setAddStockRow] = useState([
    {
      id: Date.now() + Math.random(),
      productCode: "",
      product: "",
      category: "",
      existingStock: "",
      qty: "",
      total: "",
    },
  ]);
  // Add stock  new row
  const handleAddStockRow = () => {
    setAddStockRow((prevRows) => [
      ...prevRows,
      {
        id: Date.now() + Math.random(), //it creates a unique ID based on the exact millisecond the row was added.
        productCode: "",
        product: "",
        category: "",
        existingStock: "",
        qty: "",
        total: "",
      },
    ]);
  };
  console.log("addStockRow", addStockRow);
  const totalQty = addStockRow.reduce(
    (sum, row) => sum + Number(row.qty || 0),
    0
  );
  const totalValue = addStockRow.reduce(
    (sum, row) => sum + Number(row.total || 0),
    0
  );
  // Delete add stock row
  const handleDeleteStockRow = (id) => {
    setAddStockRow((prevRows) => prevRows.filter((row) => row.id !== id));
  };
  function handleQtyChange(rowId, value) {
    const qty = Number(value);

    setAddStockRow((prevRows) =>
      prevRows.map((row) =>
        row.id === rowId //only update the matching row here  both row.id===rowId is from frontend
          ? {
              ...row,
              qty: qty,
              total: qty * Number(row.sellingPrice || 0),
            }
          : row
      )
    );
  }
  async function fetchProductDetails(rowId, productCode) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `inventory/product/${productCode}`
      );
      if (response.data.status === "success" || response.status === 200) {
        const details = response.data.data;

        setAddStockRow((prevRows) =>
          prevRows.map((row) =>
            row.id === rowId // only update the matching row here  both row.id===rowId is from frontend
              ? {
                  ...row,
                  backendId: details.id,
                  productCode: productCode,
                  product: details.product_name || "",
                  category: details.category || "",
                  existingStock: details.current_stock || "",
                  sellingPrice: details.subdistributor_selling_price || "",
                  qty: row.qty || 1,
                  total: (row.qty || 1) * details.subdistributor_selling_price,
                }
              : row
          )
        );
        console.log(
          response.data.message || "Product details fetched successfully"
        );
        // toast.success(
        //   response.data.message || "Product details fetched successfully"
        // );
      }
    } catch (error) {
      console.log("Failed to fetch product details", error);
      toast.error(
        error.response?.data?.message || "Failed to fetch product details"
      );
    } finally {
      setLoading(false);
    }
  }
  // useEffect(() => {
  //   addStockRow.forEach((row) => {
  //     if (!row.productCode) {
  //       fetchProductDetails(row.id, "pc-01"); // auto-load first option
  //     }
  //   });
  // }, []);
  
  async function LoadDropdownProductcode() {
    try {
      const response = await axiosInstance.get(
        "inventory/subdistributor/product-code/"
      );
      if (response.data.status === "success" || response.status === 200) {
        setDropdownProductCode(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to load dropdown");
      console.log("Failed to load dropdown");
    }
  }
  useEffect(() => {
    LoadDropdownProductcode();
  }, []);
  async function handleSave() {
    try {
      setLoading(true);
      const products = addStockRow.map((item) => ({
        product_id: item.backendId,
        qty: Number(item.qty) || 0,
      }));
      const payload = {
        reference_no: refNo?.trim() || "",
        received_date: receivedData,
        additional_notes: additionalNote,
        products: products,
      };
      const response = await axiosInstance.post(
        "inventory/subdistributor/incoming-stock/",
        payload
      );
      if (response.data.status === "success" || response.status === 200) {
        toast.success(response.data.message || "submitted successfully");
        console.log("submitted successfully");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to submit");
      console.log("Failed to submit");
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="inventoryContainer">
        <div className="container">
          <div className="d-flex gap-1 mb-2">
            <span className="me-2">
              <Link to="/sub-orders" style={{ color: "black" }}>
                <FaArrowLeftLong />
              </Link>
            </span>
            <div className="addModalTitle">Add Incoming Stock</div>
          </div>

          {/* Reference No & Date */}
          <div className="bulkAddGrid">
            <div>
              <label>Reference No.</label>
              <input
                type="text"
                placeholder="Enter Reference No."
                value={refNo}
                onChange={(e) => setRefNo(e.target.value)}
              />
            </div>
            <div>
              <label>Received Date</label>
              <input
                type="date"
                onChange={(e) => setReceivedData(e.target.value)}
                value={receivedData}
              />
            </div>
          </div>

          {/* Table */}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell>Product Code</TableCell>
                    <TableCell align="left">Product Name</TableCell>
                    <TableCell align="left">Category</TableCell>
                    <TableCell align="left">Existing Stock</TableCell>
                    <TableCell align="left">Selling Price</TableCell>
                    <TableCell align="left">Qty</TableCell>

                    <TableCell align="left">Total Stock</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {addStockRow.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                      className="dashboardTableBody"
                    >
                      <TableCell align="left">
                        <select
                          className="addModalQtySelect"
                          value={row.productCode}
                          onChange={(e) => {
                            fetchProductDetails(row.id, e.target.value);
                          }}
                        >
                          <option value={""} selected disabled>
                            Select
                          </option>
                          {dropdownProductcode?.map((drop) => (
                            <option value={drop.product_code}>
                              {drop.product_code}
                            </option>
                          ))}
                        </select>
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.product}
                            placeholder="Product"
                          />
                        </span> */}
                        {row.product || "---"}
                      </TableCell>

                      <TableCell align="left">
                        {row.category || "---"}
                      </TableCell>

                      <TableCell align="left">
                        {row.existingStock || "---"}
                      </TableCell>
                      <TableCell align="left">
                        {row.sellingPrice || "---"}
                      </TableCell>

                      <TableCell align="left">
                        <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.qty}
                            placeholder="Qty"
                            onChange={(e) =>
                              handleQtyChange(row.id, e.target.value)
                            }
                          />
                        </span>
                      </TableCell>

                      <TableCell align="left">{row.total || "---"}</TableCell>

                      <TableCell align="left">
                        <MdDeleteOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeleteStockRow(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* Add Row Button */}
          <div
            className="addRowText"
            onClick={handleAddStockRow}
            style={{ cursor: "pointer", marginTop: "10px" }}
          >
            + Add Row
          </div>

          {/* Totals */}
          <div className="addModalTotalContainer">
            <div>
              {/* <div className="addModalContent">
                <span>Total Items:</span>
                <span>2</span>
              </div>
              <div className="addModalContent">
                <span>Total Products Received:</span>
                <span>2400 nos</span>
              </div> */}
              <div className="addModalContent">
                <span>Total Products Received(Qty):</span>
                <span>{totalQty} nos</span>
              </div>
              <div className="addModalContent">
                <span>Total Value:</span>
                <span>₹{totalValue.toLocaleString()}</span>
              </div>
            </div>
          </div>

          {/* Notes */}
          <div className="bulkAddTextGrid">
            <div>
              <label>Additional Notes</label>
            </div>
            <div>
              <textarea
                placeholder="Type here"
                rows={4}
                value={additionalNote}
                onChange={(e) => setAdditionalNote(e.target.value)}
              ></textarea>
              <textarea placeholder="Type here" rows={4}></textarea>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end">
            <div
              className="addModalButtons"
              style={{ marginTop: "20px", display: "flex", gap: "10px" }}
            >
              <button className="addBtnCancel">Cancel</button>
              <button className="addBtnSave" onClick={handleSave}>
                Save & Add Stock
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
